import { render } from "./Import_Properties.vue?vue&type=template&id=5bd4ea2b"
import script from "./Import_Properties.vue?vue&type=script&lang=js"
export * from "./Import_Properties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__